// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-section {
  background: #232f3e;
  color: #fff;
  padding: 40px 0 20px 0;
  width: 100vw;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  padding: 0 24px;
}

.footer-contact, .footer-legal {
  flex: 1 1 250px;
  min-width: 220px;
}

.footer-contact h3, .footer-legal h3 {
  font-family: 'Montserrat', Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 16px;
  color: #4f7cff;
}

.footer-label {
  display: block;
  font-size: 0.95rem;
  color: #aaa;
  margin-bottom: 2px;
}

.footer-contact a {
  color: #fff;
  text-decoration: underline;
  font-size: 1rem;
  display: block;
  margin-bottom: 10px;
}

.footer-legal ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-link {
  background: none;
  border: none;
  color: #fff;
  font-size: 1rem;
  text-align: left;
  cursor: pointer;
  padding: 0;
  margin-bottom: 10px;
  text-decoration: underline;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #4f7cff;
}

@media (max-width: 700px) {
  .footer-container {
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
  }
}


.footer-logo-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 8px;
  background: #fff;
}

.footer-logo {
  height: 60px;
  max-width: 180px;
  object-fit: contain;
  opacity: 0.85;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".footer-section {\n  background: #232f3e;\n  color: #fff;\n  padding: 40px 0 20px 0;\n  width: 100vw;\n}\n\n.footer-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 40px;\n  padding: 0 24px;\n}\n\n.footer-contact, .footer-legal {\n  flex: 1 1 250px;\n  min-width: 220px;\n}\n\n.footer-contact h3, .footer-legal h3 {\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-size: 1.2rem;\n  font-weight: 700;\n  margin-bottom: 16px;\n  color: #4f7cff;\n}\n\n.footer-label {\n  display: block;\n  font-size: 0.95rem;\n  color: #aaa;\n  margin-bottom: 2px;\n}\n\n.footer-contact a {\n  color: #fff;\n  text-decoration: underline;\n  font-size: 1rem;\n  display: block;\n  margin-bottom: 10px;\n}\n\n.footer-legal ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-link {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 1rem;\n  text-align: left;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 10px;\n  text-decoration: underline;\n  transition: color 0.2s;\n}\n\n.footer-link:hover {\n  color: #4f7cff;\n}\n\n@media (max-width: 700px) {\n  .footer-container {\n    flex-direction: column;\n    gap: 24px;\n    align-items: flex-start;\n  }\n}\n\n\n.footer-logo-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n  margin-bottom: 8px;\n  background: #fff;\n}\n\n.footer-logo {\n  height: 60px;\n  max-width: 180px;\n  object-fit: contain;\n  opacity: 0.85;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
